module.exports = __webpack_public_path__ + "img/dateArranged.14532f3d.png";